module.exports = __webpack_public_path__ + "img/primeo-energie1.223a6d99.png";